import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import { FormattedDate, FormattedTime } from "react-intl";
import styles from "./styles/optional-date.css.js";
import withStyles from "components/with-styles";
import FormHelperText from "components/form/form-helper-text";
import Icon from "components/icon";

const Time = ({ showSeconds, value, className }) => (
  <span className={className}>
    <FormattedTime hour="numeric" minute="numeric" second={showSeconds ? "numeric" : undefined} value={value} />
  </span>
);

Time.propTypes = {
  /**
   * Clase adicional del componente
   **/
  className: PropTypes.string,
  /**
   * Fecha en cualquier formato
   **/
  value: PropTypes.any,
  /**
   * Indica si muestra los segundos
   */
  showSeconds: PropTypes.bool,
};

const OptionalDate = ({
  value,
  withTime = true,
  showSeconds = false,
  classes,
  label,
  big = false,
  className,
  icon,
}) => {
  if (!value) {
    return null;
  }

  return (
    <div className={cn(className, classes.container)}>
      {icon && <Icon className={classes.icon} name={icon} />}
      <div>
        <FormHelperText text={label}/>
        <FormattedDate value={value} />
        {withTime && <Time className={classes.time} value={value} showSeconds={showSeconds} />}
      </div>
    </div>
  );
};

OptionalDate.propTypes = {
  /**
   * Icono
   **/
  icon: PropTypes.string,
  /**
   * Clase adicional del componente
   **/
  className: PropTypes.string,
  /**
   * Aplica estilos para verse en grande
   **/
  big: PropTypes.bool,
  /**
   * Etiqueta
   **/
  label: PropTypes.string,
  /**
   * Fecha en cualquier formato
   **/
  value: PropTypes.any,
  /**
   * Indica si el campo lleva hora
   */
  withTime: PropTypes.bool,
  /**
   * Indica si muestra los segundos
   */
  showSeconds: PropTypes.bool,
};

export default withStyles(styles)(OptionalDate);
